<template>
  <div class="message">
    <ul :role="roleTemp" v-if="listMessTemp.length > 0" style="margin-bottom: 0px;">
      <li v-for="(mess, index)  in listMessTemp" :key="index" :class="classTypeTemp">
        <span class="font-weight-bold" v-html="listMessTemp[index]"></span>
      </li>
    </ul>
    <ul :role="roleTemp" v-if="mapMsgTemp != null && mapMsgTemp != undefined && mapMsgTemp.length > 0" >
      <li v-for="(item, index)  in mapMsgTemp" :key="index" :class="classTypeTemp">
        <a href="javascript:void(0)" @click="focusItem(item.key, item.ptIdScreen)"><span style="color:#dc3545" class="font-weight-bold" v-html="item.mess"></span></a>
      </li>
    </ul>
  </div>
</template>

<script>
  /* eslint-disable */
  import $ from 'jquery';
  import EventBus from "../assets/js/eventBus";
  import common from '../assets/js/common';

  export default {
    name: "message",
    data() {
      return {
        roleTemp: this.role,
        classTypeTemp: this.classType,
        listMessTemp:this.listMess,
        mapMsgTemp: this.mapMsg,
        common:common
      }
    },
    props:{
      /**
       * 
       */
      role: {
        type: String,
        default: "alert",
        required: false
      },
      /**
       * 
       */
      classType: {
        type: String,
        default: "text-danger",
        required: false
      },
      /**
       * 
       */
      listMess: {
        type: Array,
        default: function() {
          return [];
        },
        required: false
      },
      /**
       * 
       */
      mapMsg: {
        type: Array,
        default: function() {
          return [];
        },
        required: false
      }
    },
    mounted: function() {
      var _this = this;
      EventBus.$on("message", function(value) {
        _this.roleTemp = value.role ? value.role : _this.role;
        _this.classTypeTemp = value.classType ? value.classType : _this.classType;
        _this.listMessTemp = value.listMess;
        _this.mapMsgTemp = value.mapMsg;
      });
    },
    methods: {
      focusItem: function(key, ptId){
        if(ptId != null && ptId != undefined  && ptId != ''){
          $('.' + ptId + ' #' + key).focus();
        }else{
          $('#' + key).focus();
        }
          
      }
    }
  }
</script>